export const data = {
  vodafoneCash: "01062114408",
  instaPay: "sadek1975@instapay",
  email1: "mailto:yourwaytoamerica1@gmail.com",
  email2: "mailto:yourwaytoamerica2@gmail.com",
  whatsapp: "https://wa.me/201100970194",
};
